export const ItemTypes = {
  A: 'a',
  B: 'b',
  C: 'c',
  NA: 'na',
}
